
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2073.375-1766.123a23.54 23.54 0 002.842 2.446 14.968 14.968 0 002.988 1.715 7.3 7.3 0 002.832.63 4.33 4.33 0 001.689-.327 4.025 4.025 0 001.416-1.021 3.9 3.9 0 00.581-.889 2.192 2.192 0 00.22-.937 1.7 1.7 0 00-.146-.693 1.327 1.327 0 00-.5-.566l-2.842-2.012a2.525 2.525 0 00-.6-.352 1.5 1.5 0 00-.542-.107 1.212 1.212 0 00-.61.171 2.837 2.837 0 00-.61.493l-.674.645a.446.446 0 01-.352.156.547.547 0 01-.205-.039l-.166-.068a6.871 6.871 0 01-1.118-.811q-.679-.576-1.372-1.26t-1.26-1.372a6.588 6.588 0 01-.8-1.108 1.507 1.507 0 01-.073-.176.616.616 0 01-.034-.205.448.448 0 01.146-.342l.655-.67a3.2 3.2 0 00.483-.62 1.229 1.229 0 00.171-.62 1.437 1.437 0 00-.112-.527 3.272 3.272 0 00-.337-.615l-2-2.8a1.509 1.509 0 00-.586-.5 1.7 1.7 0 00-.732-.161 2.541 2.541 0 00-1.787.8 4.066 4.066 0 00-1 1.445 4.53 4.53 0 00-.312 1.68 7.312 7.312 0 00.625 2.827 14.986 14.986 0 001.694 2.969 22.832 22.832 0 002.428 2.821z"}})])])
          )
        }
      }
    